import Card from 'react-bootstrap/Card';

const CONSUMER_STATUS_BG_COLORS = {
  ACTIVE: 'bg-success',
  SUSPENDED: 'bg-danger',
  TERMINATED: 'bg-secondary',
};

const CONSUMER_STATUS_COLORS = {
  ACTIVE: 'text-white',
  SUSPENDED: 'text-white',
  TERMINATED: 'text-white',
};

function DashboardConsumers({ consumersByStatus, billableConsumers, allSubscribersToDate }) {
  return (
    <Card className="mb-3">
      <Card.Header className="d-flex justify-content-between">Consumers</Card.Header>
      {!!consumersByStatus && Object.entries(consumersByStatus).length > 0 && (
        <Card.Body>
          <div className="d-flex justify-content-center flex-wrap">
            {Object.entries(consumersByStatus).map(([key, value]) => (
              <div
                key={key}
                className={`bo-border-container rounded m-1 \
                ${CONSUMER_STATUS_BG_COLORS[key]} bo-w-120`}
              >
                <p className={`text-capitalize bo-badge ${CONSUMER_STATUS_COLORS[key]}`}>
                  {key.split('_').join(' ').toLowerCase()}
                </p>
                <p className={`text-center h4 ${CONSUMER_STATUS_COLORS[key]}`}>
                  {Number(value).toLocaleString('en-US', { maximumFractionDigits: 0 })}
                </p>
              </div>
            ))}
          </div>
        </Card.Body>
      )}
      <Card.Body className="bo-min-h-100">
        <div className="d-flex overflow-auto justify-content-center">
          {!!billableConsumers && (
            <div className="bo-border-container rounded mx-1 bo-w-200">
              <p className="text-capitalize bo-badge">Billable Consumers</p>
              <p className="text-center h4">
                {Number(billableConsumers).toLocaleString('en-US', { maximumFractionDigits: 0 })}
              </p>
            </div>
          )}
          {!!allSubscribersToDate && (
            <div className="bo-border-container rounded mx-1 bo-w-200">
              <p className="text-capitalize bo-badge">Subscribers to date</p>
              <p className="text-center h4">
                {Number(allSubscribersToDate).toLocaleString('en-US', { maximumFractionDigits: 0 })}
              </p>
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default DashboardConsumers;
